import styled from "@emotion/styled";
import { MenuItem } from "@kaltura/ds-react-components";
import { ListItemIcon } from "@mui/material";

export const StyledMenuItem = styled(MenuItem)({
    [`& > div > div`]: {
        display: "flex",
        alignItems: "center",
    },
}) as unknown as typeof MenuItem;

export const StyledListItemIcon = styled(ListItemIcon)({
    color: "inherit",
});
